import React from 'react'
import { Routes, Route } from "react-router-dom";

import { DatoScreen } from '../componentes/view/sala_venta/informacion_venta_cliente/DatoScreen';
import SalesExperienceClient from '../componentes/view/sala_venta/informacion_venta_cliente/SalesExperienceClient'; 
import HeladosPage from '../componentes/view/sala_venta/helados/create_day'; 
import CrearHelado from '../componentes/view/sala_venta/helados/create_ice_cream'; 
import AdminTiendasHelados from '../componentes/view/sala_venta/helados/admin';
import SaleProdcutsDay from '../componentes/view/sala_venta/reportes/rproductsforday';
import ProductForDate from '../componentes/view/sala_venta/reportes/productus_date';
import InvoiceForProductDay from '../componentes/view/sala_venta/reportes/invocieForProductDay';
import ReporteCajaConAPI from '../componentes/view/sala_venta/reportes/boxreportgeneral';
import ReporteCortez from '../componentes/view/sala_venta/reportes/cortez';
import GeneralSales from '../componentes/view/sala_venta/reportes/generalSales';
import Inventory from '../componentes/view/sala_venta/reportes/invetory';
import EntregasInv  from '../componentes/view/sala_venta/reportes/entregas';
import Movimientos from '../componentes/view/sala_venta/reportes/movimientos'; 
import MovimientoTienda from '../componentes/view/sala_venta/reportes/movimiento_tienda';
import DomicilioClientes from '../componentes/view/sala_venta/informacion_venta_cliente/ClientData';
import TrasladoBodegaCocina from '../componentes/view/sala_venta/traslados/trasladoCocina';
import ListTransferencia from '../componentes/view/sala_venta/traslados/listaTraslado';
import CongeladoCreacionHelados from '../componentes/view/sala_venta/traslados/congeladosTraslado';
import MarcajesRRHH from '../componentes/view/rrhh/macajes/marcaje';
import GestionAdministrativaPage from '../componentes/view/sala_venta/informacion_venta_cliente/ClientAdministrator';
import ListarGestionAdministrativaPage from '../componentes/view/sala_venta/informacion_venta_cliente/ListaGestion';
import ListaOrdenesFabricacion from '../componentes/view/sala_venta/traslados/visorFabricacionCongelado';
import FullInventorySalas from '../componentes/view/sala_venta/reportes/full_inventory_salas';
import ProductosSinExistencia from '../componentes/view/sala_venta/reportes/productossinexistencia';
import FacturasPendientes from '../componentes/view/sala_venta/reportes/facturasPendientes';
import InventoryShopify from '../componentes/view/sala_venta/reportes/invetoryShopify';
import IntegratedInventory from '../componentes/view/sala_venta/reportes/inventariosincro';
import CargaInventario from '../componentes/view/sala_venta/inventario/carga';
import CoberturaInventarioSV from '../componentes/view/sala_venta/inventario/cobertura_inventarios_sv';


export const SalaVentaRoutes = () => {

  return (
    <Routes>
      <Route path="/dato_cliente_domicilio" element={ <DatoScreen /> } />
      <Route path="/datosClientes" element={ <SalesExperienceClient /> } /> 
      <Route path="/Heladosdeldia" element={ <HeladosPage /> } /> 
      <Route path="/creacion" element={ <CrearHelado /> } /> 
      <Route path="/MantTiendaMaquinaTolba" element={ <AdminTiendasHelados /> } /> 
      <Route path="/SaleProductsDay" element={ <SaleProdcutsDay /> } /> 
      <Route path="/SaleProductsDate" element={ <ProductForDate /> } /> 
      <Route path="/invoicesaleproduct" element={ <InvoiceForProductDay /> } />
      <Route path="/cortez" element={ <ReporteCortez /> } />
      <Route path="/Salebox" element={ <ReporteCajaConAPI /> } /> 
      <Route path="/GeneralSales" element={ <GeneralSales /> } />
      <Route path="/Inventario" element={ <Inventory /> } /> 
      <Route path="/Entregas" element={ <EntregasInv/> } /> 
      <Route path="/Movimiento" element={ <Movimientos/> } /> 
      <Route path="/MovimientoTienda" element={ <MovimientoTienda/> } /> 
      <Route path="/ClientesDomicilio" element={ <DomicilioClientes/> } /> 
      <Route path="/TrasladoBodegaCocina" element={ <TrasladoBodegaCocina/> } /> 
      <Route path="/ListBodega" element={ <ListTransferencia/> } />
      <Route path="/HeladosCongelados" element={ <CongeladoCreacionHelados/> } />
      <Route path='/gestiones' element={<GestionAdministrativaPage/>} />
      <Route path='/lisgestion' element={<ListarGestionAdministrativaPage/>}/>
      <Route path='/listafabricacion' element={<ListaOrdenesFabricacion/>}/>
      <Route path='/InventarioSalasWeb' element={<FullInventorySalas/>} /> 
      <Route path='/producosSinExistencias' element={<ProductosSinExistencia/>} /> 
      <Route path='/facturaspendientes' element={<FacturasPendientes/>} />
      <Route path='/InventarioShopify' element={<InventoryShopify/>} /> 
      <Route path='/IntegracionSp' element={<IntegratedInventory/>} /> 
      <Route path='/CargaInventario' element={<CargaInventario/>} />
      <Route path='/Cobertura_Inventario_SV' element={<CoberturaInventarioSV/>} />
    </Routes>
  )
}
